import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_API_TOKENS',
    icon: 'MoreVerticalIcon',
    route: 'api-tokens',
    action: constants.action.permissionApiTokenList,
    resource: constants.resource.apiToken,
  },
]
